import * as c from 'common/c'
import { cloneDeep, uniqBy } from 'es-toolkit/compat'
import update from 'immutability-helper'

declare module 'state/notification.js' {
  export type Notification = {
    id: number
    tenantId: string
    userId: string
    message: string
    expiresAt: string
    category: string
    severity: string
    isRead: boolean
  }
}

const initialState = {
  collection: [],
  count: 0,
  hasMore: true,
  unreadCount: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.NOTIFICATIONS_FETCHED: {
      const combinedState = [
        ...action.payload.notifications,
        ...state.collection,
      ]

      const finalRecords = uniqBy(combinedState, 'id')
      return update(state, {
        //@ts-expect-error
        collection: { $set: finalRecords },
        count: { $set: action.payload.count },
        hasMore: { $set: action.payload.hasMore },
      })
    }

    case c.NOTIFICATIONS_READ: {
      const notifications = cloneDeep(state.collection)
      const pLength = action.payload.length

      for (let i = 0; i < pLength; i++) {
        const index = notifications.findIndex(
          (p: any) => p.id == action.payload[i].notificationId,
        )
        if (index > -1) {
          //@ts-ignore
          notifications[index]['isRead'] = true
        }
      }
      const updatedCount = state.unreadCount - action.payload.length
      //@ts-ignore
      return update(state, {
        collection: { $set: notifications },
        unreadCount: { $set: Math.max(updatedCount, 0) },
      })
    }

    case c.NOTIFICATIONS_READ_IDS: {
      const notifications = cloneDeep(state.collection)
      const pLength = action.payload.length

      for (let i = 0; i < pLength; i++) {
        const index = notifications.findIndex(
          (p: any) => p.id == action.payload[i],
        )
        if (index > -1) {
          //@ts-ignore
          notifications[index]['isRead'] = true
        }
      }

      const updatedCount = state.unreadCount - pLength
      //@ts-ignore
      return update(state, {
        collection: { $set: notifications },
        unreadCount: { $set: Math.max(updatedCount, 0) },
      })
    }

    case c.NOTIFICATIONS_DISMISSED: {
      const notifications = cloneDeep(state.collection)
      const pLength = action.payload.length

      for (let i = 0; i < pLength; i++) {
        const index = notifications.findIndex(
          (p: any) => p.id == action.payload[i].notificationId,
        )
        if (index > -1) {
          notifications.splice(index, 1)
        }
      }
      const updatedCount = state.count - action.payload.length
      //@ts-ignore
      return update(state, {
        collection: { $set: pLength > 0 ? notifications : [] },
        count: { $set: pLength > 0 ? updatedCount : 0 },
        unreadCount: {
          $set: updatedCount === 0 ? 0 : pLength > 0 ? state.unreadCount : 0,
        },
      })
    }

    case c.NOTIFICATIONS_ADDED: {
      //@ts-ignore
      return update(state, { collection: { $unshift: [action.payload] } })
    }

    case c.UNREAD_NOTIFICATIONS_COUNT_FETCHED: {
      //@ts-ignore
      return update(state, { unreadCount: { $set: action.payload.count } })
    }

    default:
      return state
  }
}
